$(document).ready(function() {
    $(".link-toggler span").click(function() {
        var url_item = $(this).data("toggle");
        
        if($(url_item).is(":visible")) {
            $(url_item).hide(500);
            $(this).text(show_url);
            $(this).parent().removeClass('active');
        } else {
            $(url_item).show(500);
            $(url_item + " input").focus();
            $(this).text(hide_url);            
            $(this).parent().addClass('active');
        }               
    });
})